import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { RejectDialog } from 'components/Dialog/RejectDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  useActionOnCategoryChangeStatusMutation,
} from 'generated/graphql'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React, {
  ChangeEvent,
  FC,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useParams } from 'react-router'
import { ChangeAssetCategoryDetailContent } from '../ChangeAssetCategoryDetail/ChangeAssetCategoryDetailContent'

interface CACListProps {
  filteredList: any[]
  listLoading: boolean
  listStatus: string
  userList: any[]
  fetchMore: Function
  setOriginalListing: Function
  refetch: Function
}

export const ChangeAssetCategoryPostingList: FC<CACListProps> = ({
  filteredList,
  listLoading,
  listStatus,
  userList,
  fetchMore,
  setOriginalListing,
  refetch,
}) => {
  const { CompanyID }: any = useParams()
  const { handlePermDisabled } = usePermissionChecker()
  const [postIDs, setPostIDs] = useState<Set<string>>(new Set())
  const [selectAll, setSelectAll] = useState(false)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [openRejectDialog, setOpenRejectDialog] = useState<boolean>(false)
  const [clickReject, setIsReject] = useState<boolean>(false)
  const [rejectDialogInput, setRejectDialogInput] = useState({
    RejectionRemark: '',
  })
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))

  const [actionOnCategoryChange] = useActionOnCategoryChangeStatusMutation({
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setPostIDs(new Set())
      setSelectAll(false)
      refetch?.()
    },
    onError: ({ message }) => {
      const error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
    },
  })

  const sortedList = useMemo(() => {
    return filteredList?.sort(
      (a, b) =>
        Object.values(ApprovalStatus).indexOf(a?.ApprovalStatus) -
        Object.values(ApprovalStatus).indexOf(b?.ApprovalStatus)
    )
  }, [filteredList])

  const handleCheckBoxChange = (
    e: ChangeEvent<HTMLInputElement>,
    categoryChangeID: string
  ) => {
    const newSet = new Set(postIDs)
    if (e.target.checked) {
      newSet.add(categoryChangeID)
    } else {
      newSet.delete(categoryChangeID)
      setSelectAll(false)
    }
    setPostIDs(newSet)
  }

  const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked
    setSelectAll(isChecked)

    const newSet = new Set(
      isChecked ? checkedFilteredList.map(el => el.category_change_id) : []
    )
    setPostIDs(newSet)
  }

  const checkedFilteredList =
    filteredList && filteredList.length > 0 ? filteredList : []

  const onSubmitApprove = () => {
    if (postIDs.size === 0) return

    actionOnCategoryChange({
      variables: {
        CompanyID,
        category_change_id: Array.from(postIDs),
        ApprovalStatus: ApprovalStatus.Completed,
        input: null,
      },
    })
  }

  useEffect(() => {
    if (clickReject && postIDs.size > 0) {
      actionOnCategoryChange({
        variables: {
          CompanyID,
          category_change_id: Array.from(postIDs),
          ApprovalStatus: ApprovalStatus.Rejected,
          input: {
            RejectionRemark: rejectDialogInput.RejectionRemark,
            RejectionDate: new Date().toISOString(),
          },
        },
      })
      setIsReject(false)
    }
  }, [
    clickReject,
    postIDs,
    rejectDialogInput,
    CompanyID,
    actionOnCategoryChange,
  ])

  return (
    <>
      {listLoading && <Loading />}
      <ContentWrapper overflow>
        {listStatus === 'SUBMIT' && checkedFilteredList?.length !== 0 ? (
          <span className="mdDesc flex-space" style={{ paddingLeft: '7px' }}>
            <Checkbox
              value=""
              color="primary"
              onChange={handleSelectAll}
              style={{
                marginLeft: '-5px',
                marginTop: '5px',
              }}
              checked={
                postIDs?.size > 0 &&
                postIDs?.size === checkedFilteredList?.length
              }
              disabled={handlePermDisabled({
                companyID: CompanyID,
                permEnum: AcctPermission.FixedAssetsCategoryApproveReject,
              })}
            />
            <span style={{ marginLeft: '9px' }}>Select All</span>
          </span>
        ) : null}

        <List className="core-list">
          {checkedFilteredList === undefined ||
          checkedFilteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="dd a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={checkedFilteredList.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                  updateQuery: (prev, { fetchMoreResult }) => {
                    if (!fetchMoreResult) return prev
                    return {
                      ...prev,
                      getCategoryChangeStatusListing: {
                        ...prev.getCategoryChangeStatusListing,
                        Data: [
                          ...prev.getCategoryChangeStatusListing.Data,
                          ...fetchMoreResult.getCategoryChangeStatusListing
                            .Data,
                        ],
                      },
                    }
                  },
                })
              }}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {checkedFilteredList.map((el, index) => (
                <CardExpansion
                  key={el?.category_change_id || index}
                  summary={
                    <ListItem>
                      {listStatus === 'SUBMIT' && (
                        <FormControl
                          component="fieldset"
                          style={{
                            marginLeft: '10px',
                            marginRight: '-5px',
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                value=""
                                color="primary"
                                onChange={e =>
                                  handleCheckBoxChange(
                                    e,
                                    el?.category_change_id
                                  )
                                }
                                style={{
                                  marginLeft: '10px',
                                  marginRight: '-5px',
                                }}
                                checked={postIDs.has(el?.category_change_id)}
                                disabled={handlePermDisabled({
                                  companyID: CompanyID,
                                  permEnum:
                                    AcctPermission.FixedAssetsCategoryApproveReject,
                                })}
                              />
                            }
                            label=""
                          />
                        </FormControl>
                      )}
                      <ListItemText
                        primary={
                          <>
                            <span className="desc date-width">
                              {`${formatDate(el?.change_date)}` || 'N/A'}
                            </span>
                            <span className="xsTitle flex-space">
                              {el?.DocNo}
                            </span>
                            <span className={`xsTitle`}>{el?.Asset?.name}</span>
                          </>
                        }
                        secondary={
                          <>
                            <Grid container>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={12}>
                                  <span className="desc flex-space">
                                    {`From: `}
                                    <span
                                      style={{ textDecoration: 'line-through' }}
                                    >
                                      {el?.OldCategory?.name || 'N/A'}
                                    </span>
                                  </span>
                                  <br />
                                  <span className="desc flex-space">
                                    {`To: `}
                                    <span>{el?.NewCategory?.name}</span>
                                  </span>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={12}>
                                  <span className="desc">
                                    {el?.description}
                                  </span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        }
                      />
                    </ListItem>
                  }
                >
                  <ChangeAssetCategoryDetailContent
                    listEl={el}
                    userList={userList}
                    listStatus={listStatus}
                    mode={'expansion'}
                  />
                </CardExpansion>
              ))}
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>

      {listStatus === 'SUBMIT' && (
        <AccountFooter
          options={[
            {
              name: 'Reject',
              onClick: () => setOpenRejectDialog(true),
              color: 'secondary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum: AcctPermission.FixedAssetsCategoryApproveReject,
                  }),
              },
            },
            {
              name: 'Approve',
              onClick: onSubmitApprove,
              color: 'primary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum: AcctPermission.FixedAssetsCategoryApproveReject,
                  }),
              },
            },
          ]}
        />
      )}

      <RejectDialog
        data={filteredList}
        openRejectDialog={openRejectDialog}
        setOpenRejectDialog={setOpenRejectDialog}
        setRejectDialogInput={setRejectDialogInput}
        setIsReject={setIsReject}
      />
      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg="Failed to process action"
      />
    </>
  )
}
